export class ConsultantConst {
  public static headerTable = [
    { field: 'clientName', title: 'Nombre', cell: (row) => `${row.clientName}`, class: (row) => `` },
    { field: 'clientCompanyName', title: 'Apellido o Razón Social', cell: (row) => `${row.clientCompanyName}`, class: (row) => `` },
    { field: 'clientVatNumber', title: 'CIF/NIF', cell: (row) => `${row.clientVatNumber}`, class: (row) => `` },
    { field: 'accepted', title: 'Aceptado', cell: (row) => row.accepted ? 'Aceptado' : 'No aceptado', class: (row) => `` }
  ];
}
